import { useContext } from 'react';

import { TrackingEventsContext } from '@mais-retorno-front/context/tracking-events';

export const useTrackingEvents = () => {
  return useContext(TrackingEventsContext);
};

export enum TRACK_EVENTS {
  'RETORNO_ADS' = 'retorno_ads',
}
